<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-img
        :src="require('@/assets/logo-dark.png')"
        contain
        max-width="128"
        min-height="78"
        width="100%"
      />

      <base-title
        size="body-1"
        space="4"
        title="Response Management"
        weight="regular"
      />

      <base-body>
        A lightweight response management engine that simplifies the recruitment process and reduces the HR workload.
      </base-body>

      <base-btn
        class="mb-12"
        color="white"
        outlined
        @click="$vuetify.goTo('#theme-features',options)"
      >
        More Info
      </base-btn>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseInfo',

    props: {
      title: String,
      dark: Boolean,
    },

    data: () => ({
      business: [],
    }),
  }
</script>
